import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Layout from './Layout';
export default class Field extends PureComponent {
  static propTypes = {
    /** [in development] need for create input or other node */tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /** path down refs */innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
    /** is field id */id: PropTypes.string,
    /** is field placeholder */placeholder: PropTypes.string,
    /** is field value */value: PropTypes.string,
    /** is default field value */defaultValue: PropTypes.string,
    /** is field label name */labelName: PropTypes.string,
    /** is field valid */isValid: PropTypes.bool,
    /** is field focused */isFocused: PropTypes.bool,
    /** is field has been touched */isTouched: PropTypes.bool,
    /** onFocus function * */onFocus: PropTypes.func,
    /** onBlur function * */onBlur: PropTypes.func,
    /** onChange function * */onChange: PropTypes.func,
    /** [in development] size of field */size: PropTypes.string,
    /** inner nodes */children: PropTypes.node,
    /** additional classes for field */className: PropTypes.string,
    /** error message for field validation */errors: PropTypes.arrayOf(PropTypes.string)
  };
  static defaultProps = {
    isFocused: false,
    onFocus: noop,
    onBlur: noop,
    onChange: noop
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && nextProps.value !== prevState.value) {
      return {
        value: nextProps.value
      };
    }
    return null;
  }
  state = {
    value: ''
  };
  onFocus = e => {
    this.setState({
      isFocused: true,
      isTouched: true
    });
    this.props.onFocus(e);
  };
  onBlur = e => {
    this.setState({
      isFocused: false
    });
    this.props.onBlur(e);
  };
  onChange = e => {
    const {
      target: {
        value
      }
    } = e;
    this.setState({
      value
    });
    this.props.onChange(e);
  };
  render() {
    const props = {
      ...this.props,
      ...this.state,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onChange: this.onChange
    };
    return /*#__PURE__*/React.createElement(Layout, props);
  }
}